<a [routerLink]="'/profile/appointments/' + booking.id" class="card rounded-0 text-dark">
  <div class="card-body p-2">
    <strong>{{ booking.service.name }} &#64; {{ booking.salon.name }}</strong> <span class="price">{{ booking.service.price | currency }}</span><br>
    {{ booking.start_date }} {{ booking.start_time }} (UK)<br>
    <span [class]="booking.booking_class">{{ booking.status }}</span> 
  </div>
</a>